// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GitlabOutlinedSvg from "@ant-design/icons-svg/es/asn/GitlabOutlined";
import AntdIcon from '../components/AntdIcon';

var GitlabOutlined = function GitlabOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GitlabOutlinedSvg
  }));
};

GitlabOutlined.displayName = 'GitlabOutlined';
export default React.forwardRef(GitlabOutlined);